import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import PricingCards from "@/components/PricingCards";
import { ArrowLeft } from "@phosphor-icons/react";

export default function Pricing() {
  return (
    <div className="min-h-screen bg-bg relative z-10">
      <header className="glass border-b border-border sticky top-0 z-40">
        <div className="max-w-[1200px] mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/"><Logo size="text-2xl" /></Link>
          <Link to="/" className="text-sm text-muted hover:text-fg flex items-center gap-2"><ArrowLeft size={16} /> Accueil</Link>
        </div>
      </header>
      <div className="max-w-[1200px] mx-auto px-5 py-20">
        <div className="max-w-2xl mb-12">
          <div className="overline mb-3">Tarifs interKO</div>
          <h1 className="font-display text-5xl font-extrabold mb-4">29 €/mois. Sans engagement.</h1>
          <p className="text-muted">Toutes les opportunités de mission. Un seul abonnement, toutes les fonctionnalités incluses, résiliable à tout moment.</p>
        </div>
        <PricingCards />
      </div>
    </div>
  );
}
